"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVMFeeConfigDefaultBaseFeeChangeDenominator = exports.EVMFeeConfigDefaultTargetGas = exports.EVMFeeConfigDefaultMinBaseFee = exports.EVMFeeConfigDefaultTargetBlockRate = exports.EVMFeeConfigDefaultGasLimit = exports.EVMExportTransactionTypeId = exports.EVMImportTransactionTypeId = exports.PlatformBaseTransactionTypeId = exports.TransferSupernetOwnershipTransactionTypeId = exports.PrimarySignerTypeId = exports.EmptySignerTypeId = exports.AddPermissionlessDelegatorTransactionTypeId = exports.AddPermissionlessValidatorTransactionTypeId = exports.TransformSupernetTransactionTypeId = exports.RemoveSupernetValidatorTransactionTypeId = exports.StakeableLockedOutputTypeId = exports.StakeableLockedInputTypeId = exports.PlatformExportTransactionTypeId = exports.PlatformImportTransactionTypeId = exports.CreateSupernetTransactionTypeId = exports.CreateChainTransactionTypeId = exports.AddSupernetValidatorTransactionType = exports.Secp256k1OutputOwnersTypeId = exports.SupernetAuthTypeId = exports.Secp256k1CredentialsTypeId = exports.Secp256k1OutputTypeId = exports.Secp256k1InputTypeId = exports.JVMExportTransactionTypeId = exports.JVMImportTransactionTypeId = exports.CreateAssetTransactionTypeId = exports.JVMBaseTransactionTypeId = exports.Secp256k1InitialStateFxId = exports.InvalidTypeId = exports.CodecId = exports.EVMInputSize = exports.EVMOutputSize = exports.ValidatorSize = exports.EmptySignerSize = exports.PrimarySignerSize = exports.ProofOfPossessionSize = exports.BLSSignatureSize = exports.BLSPublicKeySize = exports.NodeIdSize = exports.SignatureSize = exports.DynamicIdSize = exports.SupernetIdSize = exports.BlockchainIdSize = exports.TransactionIdSize = exports.AssetIdSize = exports.AddressSize = void 0;
exports.EVMFeeConfigDefaultBlockGasCostStep = exports.EVMFeeConfigDefaultMaxBlockGasCost = exports.EVMFeeConfigDefaultMinBlockGasCost = void 0;
exports.AddressSize = 20;
exports.AssetIdSize = 32;
exports.TransactionIdSize = 32;
exports.BlockchainIdSize = 32;
exports.SupernetIdSize = 32;
exports.DynamicIdSize = 32;
exports.SignatureSize = 65;
exports.NodeIdSize = 20;
exports.BLSPublicKeySize = 48;
exports.BLSSignatureSize = 96;
exports.ProofOfPossessionSize = exports.BLSPublicKeySize + exports.BLSSignatureSize;
exports.PrimarySignerSize = 4 + exports.ProofOfPossessionSize;
exports.EmptySignerSize = 4;
exports.ValidatorSize = exports.NodeIdSize + 3 * 8;
exports.EVMOutputSize = exports.AddressSize + 8 + exports.AssetIdSize;
exports.EVMInputSize = exports.AddressSize + 8 + exports.AssetIdSize + 8;
exports.CodecId = 0;
exports.InvalidTypeId = -1;
exports.Secp256k1InitialStateFxId = 0x00000000;
exports.JVMBaseTransactionTypeId = 0x00000000;
exports.CreateAssetTransactionTypeId = 0x00000001;
exports.JVMImportTransactionTypeId = 0x00000003;
exports.JVMExportTransactionTypeId = 0x00000004;
exports.Secp256k1InputTypeId = 0x00000005;
exports.Secp256k1OutputTypeId = 0x00000007;
exports.Secp256k1CredentialsTypeId = 0x00000009;
exports.SupernetAuthTypeId = 0x0000000a;
exports.Secp256k1OutputOwnersTypeId = 0x0000000b;
exports.AddSupernetValidatorTransactionType = 0x0000000d;
exports.CreateChainTransactionTypeId = 0x0000000f;
exports.CreateSupernetTransactionTypeId = 0x00000010;
exports.PlatformImportTransactionTypeId = 0x00000011;
exports.PlatformExportTransactionTypeId = 0x00000012;
exports.StakeableLockedInputTypeId = 0x00000015;
exports.StakeableLockedOutputTypeId = 0x00000016;
exports.RemoveSupernetValidatorTransactionTypeId = 0x00000017;
exports.TransformSupernetTransactionTypeId = 0x00000018;
exports.AddPermissionlessValidatorTransactionTypeId = 0x00000019;
exports.AddPermissionlessDelegatorTransactionTypeId = 0x0000001a;
exports.EmptySignerTypeId = 0x0000001b;
exports.PrimarySignerTypeId = 0x0000001c;
exports.TransferSupernetOwnershipTransactionTypeId = 0x00000021;
exports.PlatformBaseTransactionTypeId = 0x00000022;
exports.EVMImportTransactionTypeId = 0;
exports.EVMExportTransactionTypeId = 1;
exports.EVMFeeConfigDefaultGasLimit = 15000000;
exports.EVMFeeConfigDefaultTargetBlockRate = 2;
exports.EVMFeeConfigDefaultMinBaseFee = 25000000000;
exports.EVMFeeConfigDefaultTargetGas = 15000000;
exports.EVMFeeConfigDefaultBaseFeeChangeDenominator = 36;
exports.EVMFeeConfigDefaultMinBlockGasCost = 0;
exports.EVMFeeConfigDefaultMaxBlockGasCost = 1000000;
exports.EVMFeeConfigDefaultBlockGasCostStep = 200000;
